/* Component Dependencies */
var addressInformationFormTemplate = require('templates/addressInformationForm.hbs');
var AriesComponent = require('libs/aries-component');
var ResponsiveUtils = require('utils/responsiveUtils');
var DateHandler = require('libs/date-handler');
var $ = require('jquery');

AriesComponent.create({
  type: 'addressInformation',

  template: {
    'addressInformationForm': addressInformationFormTemplate
  },

  events: {},

  subscribe: {
    'TOGGLE_VISIBLE_ADDRESS_INFO': 'toggleVisible'
  },

  bindEvents: function () {
    window.$(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
  },

  onFormRest: function() {
    this.$el.find('input').each(function(index, input) {
      $(input).attr('value', '');
      input.value = "";
      input.readOnly = false;
    });
    this.$el.find('select option').eq(0).prop('selected', true);
  },

  toggleVisible: function(data) {
    
    var visible = data.visible,
      $input = this.$el.find('input'),
      $inputVal = $input.attr('value');
      visible ? this.$el.removeClass('is-hidden') : this.$el.addClass('is-hidden'),
      triggeredEvent = window.event;
    
    if (triggeredEvent != undefined && triggeredEvent.type != 'readystatechange') {
      this.onFormRest()
    }
  }
});
